import JSONSchemaConverterFormField from "../../../shared/JSONSchemaConverterFormField";
import { BlueprintParameterSchema } from "../../../../models/Blueprints";
import { useEffect, useState } from "react";
import { ButtonVariant, Dialog } from "@merge-api/merge-javascript-shared";
import { showErrorToast } from "../../../shared/Toasts";

interface Props {
  schema: undefined | BlueprintParameterSchema<any>;
  setSchema: (x: undefined | BlueprintParameterSchema<any>) => void;
  isShowingSchemaEditor: boolean;
  setIsShowingSchemaEditor: (x: boolean) => void;
}

const ParameterSchemaEditorModal = ({
  schema,
  setSchema,
  isShowingSchemaEditor,
  setIsShowingSchemaEditor,
}: Props) => {
  const [parameterSchemaString, setParameterSchemaString] = useState<string>("");
  useEffect(() => {
    if (schema) {
      setParameterSchemaString(JSON.stringify(schema, null, 2));
    }
  }, [schema]);

  const parseAndSetSchema = () => {
    try {
      setSchema(JSON.parse(parameterSchemaString));
      return true;
    } catch (error) {
      showErrorToast(`Failed to parse schema: ${error}`);
      return false;
    }
  };

  return (
    <Dialog
      open={isShowingSchemaEditor}
      onClose={() => {
        setIsShowingSchemaEditor(false);
      }}
      title="Edit parameter schema"
      primaryButtonText="Set schema"
      onPrimaryButtonClick={() => {
        const isSuccess = parseAndSetSchema();
        setIsShowingSchemaEditor(!isSuccess);
      }}
      primaryButtonVariant={ButtonVariant.PrimaryGray}
      hideSecondaryButton
    >
      <JSONSchemaConverterFormField
        currentValue={parameterSchemaString}
        setValue={(newParamaterSchema) => {
          setParameterSchemaString(newParamaterSchema);
        }}
        numRows={5}
      />
    </Dialog>
  );
};

export default ParameterSchemaEditorModal;
